// extracted by mini-css-extract-plugin
export var dropdownButton = "_10-0";
export var fullWidthDropdownButton = "_10-1";
export var icon = "_10-3";
export var iconPlaceholder = "_10-2";
export var shortcutContainer = "_10-4";